import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack, Icon } from '~/components/atomic';

interface CharacterLikedCountProps {
  liked_count: number;
}

export default function CharacterLikedCount({
  liked_count,
}: CharacterLikedCountProps) {
  return (
    <Like direction='row' className='like' spacing={4}>
      <Icon size={20} iconName='Favorite' />
      <span>{liked_count}</span>
    </Like>
  );
}

const Like = styled(FlexStack)`
  ${({ theme }) => css`
    align-items: center;
    gap: 2px;
    color: ${theme.content.content_light_4};

    span {
      color: ${theme.content.content_light_4};
      ${theme.fontStyle.text.caption_medium};
    }
  `}
`;
